// frontend/src/services/userSettingsService.js
// =============================================================================
// Frontend API wrapper for current-user preferences.
// =============================================================================

import apiClient from "../utils/apiClient";

const SUPPORTED_LANGUAGES = new Set(["en", "pl"]);

function normalizeLanguage(value) {
  const lang = String(value || "").trim().toLowerCase();
  return SUPPORTED_LANGUAGES.has(lang) ? lang : "en";
}

function getErrorMessage(err) {
  return err?.response?.data?.message || err?.response?.data?.error || err?.response?.data?.detail || err?.message || "Request failed";
}

function throwApiError(context, err) {
  const e = new Error(`${context}: ${getErrorMessage(err)}`);
  e.status = err?.response?.status;
  e.data = err?.response?.data;
  e.code = err?.response?.data?.code || err?.code;
  throw e;
}

export async function fetchMyUserSettings() {
  try {
    const res = await apiClient.get("/user-settings/me", { withCredentials: true });
    return res?.data || { preferred_language: "en" };
  } catch (err) {
    throwApiError("fetchMyUserSettings", err);
  }
}

export async function updateMyPreferredLanguage(preferredLanguage) {
  try {
    const preferred_language = normalizeLanguage(preferredLanguage);
    const res = await apiClient.put("/user-settings/me", { preferred_language }, { withCredentials: true, headers: { "Content-Type": "application/json" } });
    return res?.data || { preferred_language };
  } catch (err) {
    throwApiError("updateMyPreferredLanguage", err);
  }
}
